module.exports = __webpack_public_path__ + "static/media/hero_mom_window.c06b0d40.svg";